export default "__VITE_ASSET__D75HvoGx__"